import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { valueTable } from '../data/content';
export function Offer() {
  return <section className="w-full bg-brand-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-173" data-mp="1mmr24g0pg5ui">
      <div className="mx-auto max-w-2xl" data-id="element-174" data-mp="1hpqqzqp00cwj">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-gold" data-id="element-175" data-mp="1hqs7iaos9rln">
          Offerta speciale di lancio
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-176" data-mp="p0tjmimbs0ik">
          Hai già tutto questo. Ora guarda il valore complessivo.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] font-medium leading-relaxed text-white/75 sm:text-lg" data-id="element-177" data-mp="ywd50b39jgt2">
          Oggi non acquisti semplicemente un PDF: ottieni un Percorso Clinico completo per valutare,
          trattare e monitorare i tuoi pazienti con più chiarezza e meno tempo perso.
        </p>

        <div className="mt-9 overflow-hidden rounded-3xl border border-white/15 bg-white/5" data-id="element-178" data-mp="pmbgpus6v45i">
          <div className="flex items-center justify-between border-b border-white/10 px-4 py-3 sm:px-6" data-id="element-179" data-mp="ulenpkrqbkg4">
            <span className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-white/60" data-id="element-180" data-mp="zgajmw036ryi">
              Contenuto
            </span>
            <span className="text-[10px] font-extrabold uppercase tracking-[0.16em] text-white/60" data-id="element-181" data-mp="6uiow3ouvozd">
              Valore
            </span>
          </div>
          <ul data-id="element-182" data-mp="bqpt9s1lssf7">
            {valueTable.map(row => <li key={row.item} className="flex items-start justify-between gap-3 border-b border-white/10 px-4 py-3 sm:px-6" data-id="element-183" data-mp="ftcqk8h1n5js">
                <span className="text-[14px] font-medium leading-snug text-white/90 sm:text-[15px]" data-id="element-184" data-mp="3k95jod6asvhn">
                  {row.item}
                </span>
                <span className="shrink-0 font-display text-[15px] font-bold text-white/60 line-through sm:text-base" data-id="element-185" data-mp="3o8efroot95gd">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between px-4 py-4 sm:px-6" data-id="element-186" data-mp="qete3na6mepn">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-187" data-mp="154r0pysgqwcq">
              Valore totale
            </span>
            <span className="font-display text-2xl font-bold text-gold line-through" data-id="element-188" data-mp="cgcxn4mip9ub">€282</span>
          </div>
        </div>

        <div className="mt-8 rounded-3xl bg-white p-6 text-center sm:p-8" data-id="element-189" data-mp="7iti81e32r0s">
          <p className="text-[12px] font-extrabold uppercase leading-snug tracking-[0.14em] text-inksoft" data-id="element-190" data-mp="li2q8ds4yeto">
            Oggi ottieni l’accesso completo a soli
          </p>
          <p className="mt-2 font-display text-[64px] font-extrabold leading-none text-brand-500 sm:text-7xl" data-id="element-191" data-mp="hic08cafo2q7">
            €19
          </p>
          <p className="mt-3 text-[14px] font-bold leading-snug text-ink sm:text-base" data-id="element-192" data-mp="1su342i140a74">
            Un unico pagamento. Nessun abbonamento. Nessun rinnovo. Accesso a vita.
          </p>
          <p className="mx-auto mt-3 flex max-w-sm items-start justify-center gap-2 text-[12px] font-medium leading-snug text-inksoft" data-id="element-193" data-mp="25e9weq2g96yq">
            <GlobeIcon className="mt-[2px] h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" data-id="element-194" data-mp="1qi0zhv6175ph" />
            Il cambio di valuta è automatico: il prezzo verrà mostrato nella valuta del tuo Paese.
          </p>

          <div className="mt-6" data-id="element-195" data-mp="2j5x1nfeddptn">
            <CtaButton label="Voglio il Kit Clinico ora" note="Download immediato · Accesso a vita · Pagamento unico" data-id="element-196" data-mp="2o3ymo5vcvz7r" />
          </div>

          <div className="mt-6" data-id="element-197" data-mp="29d958lraxnvg">
            <Countdown data-id="element-198" data-mp="2edww97fj64po" />
          </div>

          <div className="mt-6" data-id="element-199" data-mp="2ecu8v9hf2kei">
            <ScarcityBar data-id="element-200" data-mp="323zmrj3sr2m6" />
          </div>
        </div>
      </div>
    </section>;
}